import React, { useCallback, useContext, useEffect, useState } from 'react';

import api from '../api';
import { formatData } from '../../providersHelpers';
import { useGet } from '../../apiHooks';
import { Context as AuthContext } from '../../auth/context';

import Context from './context';

interface Props {
    children: React.ReactNode;
}

const CountryCodesProvider: React.FC<Props> = (props: Props) => {
    const { children } = props;
    const [data, setData] = useState({ byId: {}, ids: [], asArray: [] });
    const [, setError] = useState({});

    const authContext = useContext(AuthContext);
    useEffect(() => {
        if (authContext.currUser) {
            get({});
        }
    }, [authContext.currUser]); // eslint-disable-line

    const handleGetData = useCallback((res) => {
        setData({ ...formatData(res), asArray: res });
        return res;
    }, []);
    const get = useGet(api, data, handleGetData, setError);

    return <Context.Provider value={{ get, data }}>{children}</Context.Provider>;
};

export default CountryCodesProvider;
